import React, { useContext } from "react";
import AuthContext from "../../../../context/auth-context";
import { Link } from "react-router-dom";
import * as S from "./styles"
// import {
//   translateAccountStatus,
//   accountStatusSiglum,
//   translateAlertAccountStatus,
//   accountAlertStatusSiglum
// } from "../../utils/utils";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import moment from "moment";
import { Tooltip } from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles"
import { account_type_translations } from "../../utils/utils"
import { useTranslation } from "react-i18next"

const useStyles = makeStyles((theme) => ({
  tableStyle: {
    border: "none",
    boxShadow: "none",
  },
  blueText: {
    fontFamily: "Open Sans",
    fontWeight: "600",
    color: "#0b1f82",
  },
  tableText: {
    fontFamily: "Open Sans",
    fontSize: "15px",
    lineHeight: "16px",
    textAlign: "center",
    margin: "10px",
    padding: "25px",
  },
  tableHeader: {
    textAlign: "center",
    fontFamily: "Open Sans",
    fontStyle: "normal",
    fontWeight: "normal",
    color: "#6F6F6F",
    fontSize: "16px",
    lineHeight: "19px",
    padding: "15px",
  },
  tableRow: {
    textAlign: "center",
    fontFamily: "Open Sans",
    fontStyle: "normal",
    fontWeight: "normal",
    color: "#6F6F6F",
    fontSize: "20px",
    lineHeight: "19px",
    padding: "6px",
    marginBottom: "20px",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.37)",
    transition: "background-color 0.3s ease",
    "&:hover": {
      backgroundColor: "#f0f0f0",
    }
  }
}));

function DeviceManagerAccountTable(props) {
  let user_data = useContext(AuthContext).user_data;

  const classes = useStyles()

  const { t } = useTranslation()

  const { account_type, not_listed } = account_type_translations

  useTheme()

  let { dataList } = props

  return (
    <Table style={{ padding: "8px" }}>
      <TableHead>
        <TableRow>
          <TableCell className={classes.tableHeader}>{t("account_id")}</TableCell>
          {user_data.business_group_key &&
            <TableCell className={classes.tableHeader}>{t("company_name")}</TableCell>}
          <TableCell className={classes.tableHeader}>{t("account_type")}</TableCell>
          <TableCell className={classes.tableHeader}>{t("agency")}</TableCell>
          <TableCell className={classes.tableHeader}>{t("account")}</TableCell>
          <TableCell className={classes.tableHeader}>{t("registration_date")}</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {dataList.map((account, index) => (
          <React.Fragment key={index}>
            <S.StyledTableRow>
              <TableCell className={classes.tableText}>
                <Link
                  className={["listCardItem", "link", "subtitleSize", "bold"].join(" ")}
                  style={{ flex: "2 1 120px", textAlign: "center" }}
                  to={"/device-manager-account/" + account.account_key}
                >
                  {account.external_id}
                </Link>
              </TableCell>
              {user_data.business_group_key &&
                <TableCell className={classes.tableText}>
                  {account.company_name}
                </TableCell>}
              <TableCell className={classes.tableText}>
                <Tooltip title={<p className="tooltipText">{account_type[account.account_type] ? t(account_type[account.account_type].description) : t(account.account_type)}</p>}>
                  <div className={["circle", "small"].join(" ")} style={{backgroundColor: (account_type[account.account_type] || not_listed).color }}>
                    {t((account_type[account.account_type] || not_listed).siglum)}
                  </div>
                </Tooltip>
              </TableCell>
              <TableCell className={classes.tableText}>
                  <div>
                    {account.account_data?.agency_number ?? t("not_informed")}
                  </div>
              </TableCell>
              <TableCell className={classes.tableText}>
                  <div>
                    {account.account_data?.account_number ?? t("not_informed")}
                  </div>
              </TableCell>
              <TableCell className={classes.tableText}>
                {moment(account.registration_date).format(
                  "DD/MM/YYYY HH:mm:ss"
                )}
              </TableCell>
            </S.StyledTableRow>
          </React.Fragment>
        ))}
      </TableBody>
    </Table>
  );
}

export default DeviceManagerAccountTable
